import React from 'react';
import { Link } from 'react-router-dom';
import SimplePanel from './SimplePanel';
import { AlienArt, PlanetArt, RocketArt } from './SpaceArt';
import LayeredCardHero from './LayeredCardHero';
import styles from './Simple.module.css';

const collections = [
  { title: 'Trading cards', description: 'Discover your next favorite Pokémon, TCG, or collectible card.', Art: AlienArt, tone: 'lime' },
  { title: 'Sports cards', description: 'Explore players, teams, and memorable moments worth collecting.', Art: RocketArt, tone: 'cyan' },
  { title: 'Graded finds', description: 'Take a closer look at the details, images, and grades.', Art: PlanetArt, tone: 'purple' },
];

export default function SimpleHome() {
  return (
    <div className={styles.home} data-simple-home>
      <div className={styles.content}>
        <section className={styles.hero} aria-labelledby="simple-home-title">
          <div className={styles.intro}>
            <p className={styles.eyebrow}><span /> A universe of collectibles</p>
            <h1 id="simple-home-title" className={styles.title}>Alien Trader <span>Co.</span></h1>
            <p className={styles.tagline}>Great cards.<br />Cosmic discoveries.</p>
            <p className={styles.description}>Trading cards, sports cards, and collectibles for your next great find. Welcome aboard.</p>
            <div className={styles.actions}>
              <a className={styles.primaryButton} href="https://www.ebay.com/str/alientraderco">Explore our eBay Store <span aria-hidden="true">↗</span></a>
              <Link className={styles.secondaryButton} to="/cards">Browse cards <span aria-hidden="true">→</span></Link>
            </div>
          </div>
          <LayeredCardHero>
            <div className={styles.featuredCard} aria-label="Featured card illustration">
              <AlienArt />
              <span>Alien Trader Co.</span>
              <small>A universe of collectibles</small>
            </div>
          </LayeredCardHero>
        </section>

        <SimplePanel className={styles.welcome} aria-labelledby="simple-welcome-title">
          <div className={styles.alienBadge}><AlienArt /></div>
          <div>
            <p className={styles.eyebrow}>Earth collectors welcome</p>
            <h2 id="simple-welcome-title" className={styles.sectionTitle}>Your collection. A little more out of this world.</h2>
            <p>Welcome to Alien Trader Co. We're a team of intergalactic traders on a mission to bring you trading cards, sports cards, and collectibles worth exploring. Come on in and browse our collection—there's a whole universe to discover.</p>
          </div>
        </SimplePanel>

        <section className={styles.collection} aria-labelledby="simple-collection-title">
          <div className={styles.sectionHeading}>
            <div><p className={styles.eyebrow}>Find your orbit</p><h2 id="simple-collection-title" className={styles.sectionTitle}>Made for the collector in you.</h2></div>
            <Link to="/cards" className={styles.textLink}>Explore cards <span aria-hidden="true">→</span></Link>
          </div>
          <div className={styles.collectionGrid}>
            {collections.map(({ title, description, Art, tone }) => (
              <SimplePanel key={title} as="article" className={styles.collectionCard} data-tone={tone}>
                <div className={styles.cardIllustration}><div className={styles.cardOrbit} /><Art /></div>
                <h3>{title}</h3><p>{description}</p>
              </SimplePanel>
            ))}
          </div>
        </section>

        <SimplePanel className={styles.visit} aria-labelledby="simple-visit-title">
          <div><p className={styles.eyebrow}>Next stop: your collection</p><h2 id="simple-visit-title" className={styles.sectionTitle}>Ready for a cosmic discovery?</h2><p>Visit our store to see what's waiting for you.</p></div>
          <a className={styles.primaryButton} href="https://www.ebay.com/str/alientraderco">Visit eBay Store <span aria-hidden="true">↗</span></a>
        </SimplePanel>
      </div>
    </div>
  );
}
